module.exports = __webpack_public_path__ + "img/acaki8.c5bbc253.jpg";